import { Reveal } from "./Reveal";
import { Mail, MapPin, Instagram } from "lucide-react";

const contacts = [
  { icon: Mail, label: "Email", value: "9jaclicks1@gmail.com", href: "mailto:9jaclicks1@gmail.com", testid: "contact-email" },
  { icon: MapPin, label: "Studio", value: "1115 Willowgrove Crescent, Saskatoon, S7W 1J4", href: "#", testid: "contact-address" },
];

export default function Footer() {
  return (
    <footer id="contact" data-testid="footer-section" className="relative border-t border-white/5">
      {/* CTA */}
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-40">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="overline mb-6">Let's Create</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-heading font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tighter">
                Begin your
                <br />
                <span className="italic text-gold">extraordinary.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-lg font-light leading-relaxed text-foreground/70">
                Whether an unforgettable celebration or a life lived with less friction, our team is ready to bring your
                vision to life. Reach out for a private consultation.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                href="mailto:9jaclicks1@gmail.com"
                data-testid="footer-cta-button"
                className="mt-10 inline-block bg-gold text-primary-foreground px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-gold/90 transition-all duration-500"
              >
                Book a Consultation
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-5 flex flex-col justify-end gap-8">
            {contacts.map((c) => (
              <Reveal key={c.label} delay={0.15}>
                <a
                  href={c.href}
                  data-testid={c.testid}
                  className="group flex items-center gap-5 border-b border-white/10 pb-6 hover:border-gold/50 transition-colors duration-500"
                >
                  <c.icon size={20} className="text-gold shrink-0" />
                  <div>
                    <p className="text-xs uppercase tracking-[0.2em] text-foreground/40">{c.label}</p>
                    <p className="mt-1 text-lg font-light group-hover:text-gold transition-colors duration-300">{c.value}</p>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-baseline gap-[2px]">
            <span className="font-heading text-xl text-foreground">9ja</span>
            <span className="font-heading text-xl text-gold">clicks</span>
            <span className="ml-3 text-xs text-foreground/40">Limited — Events & Lifestyle</span>
          </div>
          <div className="flex items-center gap-6">
            <a
              href="#"
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="text-foreground/50 hover:text-gold transition-colors"
            >
              <Instagram size={18} />
            </a>
            <p className="text-xs text-foreground/40">© {new Date().getFullYear()} 9jaclicks Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
